<small
  class="p-error"
  [ngClass]="className"
  *ngIf="control && control.errors && control.errors[errorName] && isShowError"
>
  <ng-template [ngIf]="fieldName">
    {{ errorMsg | translate: { fieldName: fieldName | translate } }}
  </ng-template>
  <ng-template [ngIf]="!fieldName && !errorDesc && !translateErrorMsg">
    {{ errorMsg | translate }}
  </ng-template>
  <ng-template [ngIf]="errorDesc">
    {{ errorMsg | translate: { limit: errorDesc } }}
  </ng-template>
  <ng-template [ngIf]="translateErrorMsg">
    {{ translateErrorMsg }}
  </ng-template>
</small>
